import React from 'react';

const Features = () => {
  return (
    <div style={{ padding: '40px' }}>
      <h2>Our Features</h2>
      <p>Details about the features will go here.</p>
    </div>
  );
};

export default Features;
